import React from "react";
import Layout from "../layouts/layout";
import Index from "../components/liveTest";

export default function LiveTest() {
  return (
    <>
      <Layout>
        <Index />
      </Layout>
    </>
  );
}
